module.exports = __webpack_public_path__ + "img/PayPal.09ca5954.svg";